module.exports = __webpack_public_path__ + "img/page2.24b530fd.png";